const dataPrivacyConfig = {
  permission: {
    default: {
      iconName: 'fingerprint',
    },
    dw2: {
      iconName: 'offers',
    },
  },
  manageCookie: {
    default: {
      iconName: 'activity',
    },
    dw2: {
      iconName: 'manage',
    },
  },
  marketing: {
    default: {
      iconName: 'heart',
    },
    dw2: {
      iconName: 'deals',
    },
  },
  shopping: {
    default: {
      iconName: 'cart',
    },
    dw2: {
      iconName: 'shopping',
    },
  },
  searchPrivacy: {
    default: {
      iconName: 'show-alt',
    },
    dw2: {
      iconName: 'search',
    },
  },
  blockedContacts: {
    default: {
      iconName: 'contact-info',
    },
    dw2: {
      iconName: 'cancel',
    },
  },
}
const subSectionBadgeClaasName = 'subSection-badge'
const dataPlatformConfig = {
  downloadData: {
    default: {
      iconName: 'download',
      badge: {
        open: { type: 'success', className: subSectionBadgeClaasName },
        progress: { type: 'neutral', className: subSectionBadgeClaasName },
        download: { type: 'feature', className: subSectionBadgeClaasName },
      },
    },
    dw2: {
      iconName: 'download',
      badge: {
        open: { type: 'feature', className: '' },
        progress: { type: 'feature', className: '' },
        download: { type: 'success', className: '' },
      },
    },
  },
  correctData: {
    default: {
      iconName: 'edit',
    },
    dw2: {
      iconName: 'information',
    },
  },
  verificationData: {
    default: {
      iconName: 'smartphone-photo',
    },
    dw2: {
      iconName: 'smartphone-photo',
    },
  },
  deleteData: {
    default: {
      iconName: 'trash',
    },
    dw2: {
      iconName: 'delete',
    },
  },
}

export { dataPrivacyConfig, dataPlatformConfig }
